import { Grid, Radio } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Button, SelectBox, SVG, Text } from "sunrise-ui";
import FilterComponent from "../../../components/helperComponents/FilterComponent";
import { CHART_COLORS, customTooltip } from "../../../constants/reactChartConstants";
import { getMachineDeploymentData } from "../../../redux/reducers/reportReducer";
import { AppDispatch } from "../../../redux/store";
import SelectOptionMsg from "../../../utilities/SelectOptionMsg";

//-------bar chart data------------

const barChartDataset: any = [
    {
        label: "Week 1",
        data: [0, 0, 0, 0],
        backgroundColor: [CHART_COLORS.BLUE],
        hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE],
        barThickness: 20
    },
    {
        label: "Week 2",
        data: [0, 0, 0, 0],
        backgroundColor: [CHART_COLORS.YELLOW],
        hoverBackgroundColor: [CHART_COLORS.SELECTED_YELLOW],
        barThickness: 20
    },
    {
        label: "Week 3",
        data: [0, 0, 0, 0],
        backgroundColor: [CHART_COLORS.RED],
        hoverBackgroundColor: [CHART_COLORS.SELECTED_RED],
        barThickness: 20
    },
    {
        label: "Week 4",
        data: [0, 0, 0, 0],
        backgroundColor: [CHART_COLORS.GREEN],
        hoverBackgroundColor: [CHART_COLORS.SELECTED_GREEN],
        barThickness: 20
    },
    {
        label: "Week 5",
        data: [0, 0, 0, 0],
        backgroundColor: [CHART_COLORS.ORANGE],
        hoverBackgroundColor: [CHART_COLORS.SELECTED_ORANGE],
        barThickness: 20
    },
    {
        label: "Week 6",
        data: [0, 0, 0, 0],
        backgroundColor: [CHART_COLORS.VIOLET],
        hoverBackgroundColor: [CHART_COLORS.SELECTED_VIOLET],
        barThickness: 20
    },
];

const barChartData: any = {
    labels: ["March' 22", "April' 22", "May' 22", "June' 22", "July' 22", "August' 22"],
    datasets: [],
};


const deploymentReportBarOptions: any = {
    plugins: {
        tooltip: customTooltip,
        legend: {
            display: false
        }
    },
    maintainAspectRatio: false,
    scales: {
        y: { title: { display: true, text: 'Machine Details', font: { weight: 'bold' } }, stacked: true },
        x: { title: { display: true, text: 'Month and Year', font: { weight: 'bold' } }, stacked: true, },
    }
}

const MachineDeploymentReport = ({ machineTypeList, projectList, allProjects }: any) => {

    const [projectName, setProjectName] = useState("");
    const [projectId, setProjectId] = useState("");
    const [machineType, setMachineType] = useState("");

    const [graphLabels, setGraphLabels] = useState([]);
    const [graphData, setGraphData] = useState(barChartDataset);

    const [isAscending, setIsAscending] = useState(true);
    const [dateRange, setDateRange] = useState({ from: '', to: '' });
    const dispatch = useDispatch<AppDispatch>();

    const machineDeploymentData = useSelector((state: any) => state.REPORT.machineDeploymentData);

    const resetData = () => {
        setMachineType("");
        setDateRange({ from: '', to: '' });
        setProjectId("");
    }

    const setObjectId = (
        list: Array<any>,
        index: any,
        setMethod: Function,
        key: string
    ) => {
        setMethod(list[index][key]);
    };

    const handleFilterDate = () => { };

    const changeResetValue = () => { };

    const resetToAll = () => { };

    const handleSearch = () => {
        dispatch(
            getMachineDeploymentData({
                endPoint: `reports/get-machine-deployment?project=${projectId}&startDate=${dateRange?.from}&endDate=${dateRange?.to}&type=${machineType}`,
            })
        );
    }

    const calculateGraphWeekData = (weeks: any) => {
        const weekData = [];
        for (let i = 0; i < 6; i++) {
            if (weeks[i]) {
                const days = (weeks[i].value / (60 * 60 * 24))
                weekData.push(days)
            } else {
                weekData.push(0)
            }
        }


        return weekData;
    }

    const getDeploymentWeekWiseData = (machineDeploymentData: any) => {
        const graphWeekData: any = [];
        // const tempDataset = {...barChartDataset, }
        machineDeploymentData.forEach((deployData: any) => {
            const weekData = calculateGraphWeekData(deployData?.weeks);
            for (let i = 0; i < 6; i++) {
                if (graphWeekData[i]) {
                    graphWeekData[i].push(weekData[i]);
                } else {
                    graphWeekData[i] = [weekData[i]]
                }
            }
        });

        for (let i = 0; i < 6; i++) {
            barChartDataset[i].data = graphWeekData[i];
        }
        return [...barChartDataset]
    }

    useEffect(() => {
        resetData();
        handleSearch();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (machineDeploymentData) {
            const labels = machineDeploymentData?.map((label: any) => `${label?.month} ${label?.year}`);
            setGraphLabels(labels)
            const dataset = getDeploymentWeekWiseData(machineDeploymentData);
            setGraphData(dataset);
        }
        // eslint-disable-next-line
    }, [machineDeploymentData])

    return (
        (
            <Grid container xs={12} className="d-flex bg--white box--shadow p1 mt1 mr-1">
                <Grid item xs={12}>
                    <Grid item xs={12} container spacing={2}>
                        <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={18}
                                className="mb1 mt0"
                            >
                                <span className="fw500">Monthly Machine Deployment Report</span>
                            </Text>
                        </Grid>
                    </Grid>

                    <Grid className="d-flex">
                        <Grid className="radio_box">
                            <Radio
                                checked={
                                    isAscending
                                }
                                onChange={(e) => {
                                    //handleStepChange(index, e);
                                    setIsAscending(true);
                                }}
                                value="mandatory"
                                name="isMandatory"
                                inputProps={{ "aria-label": "Mandatory" }}
                                color="primary"
                            />
                            <label>Ascending</label>
                            <Radio
                                checked={
                                    !isAscending
                                }
                                onChange={(e) => {
                                    setIsAscending(false);
                                }}
                                value="optional"
                                name="isMandatory"
                                inputProps={{ "aria-label": "Optional" }}
                                color="primary"
                            />
                            <label>Desending</label>
                        </Grid>
                    </Grid>

                    <Grid xs={12} spacing={2} container>
                        <Grid item xs={3} className="">
                            <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt0">
                                <span className="fw500">Select Project</span>
                            </Text>
                            <SelectBox
                                data={projectList}
                                placeHolder="Select Project"
                                defaultVal={projectName}
                                resetVal={projectName === "" ? true : false}
                                changeReset={changeResetValue}
                                onChange={(e) => {
                                    let target = { ...e };
                                    setProjectName(target.target.value);
                                    const index = projectList
                                        ?.map((item: any) => item)
                                        .indexOf(target.target.value);
                                    setObjectId(allProjects, index, setProjectId, "_id");
                                    setMachineType("");
                                    setDateRange({ from: '', to: '' });
                                }}
                                borderColor={"primary"}
                            />
                        </Grid>
                        <Grid item xs={3} className="ml-1">
                            <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt0">
                                <span className="fw500">Select Machine Type</span>
                            </Text>
                            <SelectBox
                                data={machineTypeList}
                                placeHolder="Select Type"
                                borderColor={"primary"}
                                defaultVal={machineType}
                                resetVal={machineType === "" ? true : false}
                                changeReset={changeResetValue}
                                onChange={(e) => {
                                    setMachineType(e.target.value);
                                    setDateRange({ from: '', to: '' });
                                }}
                            />
                        </Grid>
                        <Grid item className={"ml-1"}
                            direction="row"
                            alignItems="center">
                            <div className="filter_box filter_box_mr0 mt2">
                                <FilterComponent
                                    handleFilterDate={handleFilterDate}
                                    setValue={setDateRange}
                                    value={dateRange}
                                    resetAll={resetToAll}
                                />
                            </div>
                        </Grid>
                        <Grid item className="mt2 ml-1">
                            <Button
                                type="button"
                                size="medium"
                                isRounded={true}
                                category="primary"
                                onClick={handleSearch}
                                className="submit_button mt2 mb1 mr-1 pl pr f14"
                            >
                                <SVG type={"searchIcon"} />
                                Search
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>

                {(machineType && machineDeploymentData?.length > 0) ?
                    <Grid item xs={11} style={{ height: 300 }} className="mt1" >
                        <Bar data={{ ...barChartData, labels: graphLabels, datasets: graphData }} options={deploymentReportBarOptions} />
                    </Grid> :
                    <SelectOptionMsg
                        text={`Select Options and Search`}
                    />
                }
            </Grid>
        )
    );
}

export default MachineDeploymentReport;